/*----------------------
   VARIATIONS
---------------------- */
// requires formatMoney function in js-common.js
var Variations = {
    init: function () {
        let sections = [];
        let currentSelected = [];
        let availableCombos = [];

        function normalizeOptionValue(value) {
            return String(value || '').replaceAll(' / ', '/').trim();
        }

        function refreshPrice() {
            let variant = currentSelectedComboProperties();

            // Simple product (no variant options): use the single combo directly
            if (!variant && sections.length === 0 && availableCombos.length > 0) {
                variant = availableCombos[0];
            }

            if (!variant) {
                let el = $("[name='price']");
                $(el).html("-");
                console.info("Current selected variant not found on combo, cannot update price");

                $(".button-add-cart")
                    .addClass("product-unavailable")
                    .removeClass("product-available")
                    .prop("disabled", true)
                    .attr("disabled", "disabled");

                return;
            }

            // update price
            let el = $("[name='price']");
            $(el).attr("data-price", variant[4]);
            $(el).attr("data-price-sale", variant[5]);
            $(el).html(formatMoney(variant[4]));

            if (variant[4] != variant[5] && variant[5] > 0) {
                $(".price__sale .price-item").html(formatMoney(variant[5]));
            } else {
                $(".price__sale .price-item").html("");
            }

            // update id
            $(".button-add-cart").attr("data-id", variant[1]);
            $(".product-form input.product-variant-id").val(variant[1]);

            // update availability + disabled
            if (!variant[2]) {
                $(".button-add-cart")
                    .addClass("product-unavailable")
                    .removeClass("product-available")
                    .prop("disabled", true)
                    .attr("disabled", "disabled");
            } else {
                $(".button-add-cart")
                    .removeClass("product-unavailable")
                    .addClass("product-available")
                    .prop("disabled", false)
                    .removeAttr("disabled");
            }

            // change URL
            var url = window.location.href;
            var parts = url.split("?");
            var urlWithoutParams = parts[0];
            urlWithoutParams += "?variant=" + variant[1];
            history.pushState(null, null, urlWithoutParams);
        }


        //IMAGES STICKY
        /*
        function GotoImages() {
            let variant = currentSelectedComboProperties();
            if (!variant) return;

            if (variant[6] != null) {
                let image = $('.product__images').find('[data-media="' + variant[6] + '"]');
                if (!image.length) return;

                var height_menu = $(".header-menu").outerHeight() || 0;
                $('html, body').animate({
                    scrollTop: parseInt(image.offset().top - height_menu, 10)
                }, 300);
            }
        }
            */

        //IMAGES SLIDER
        function GotoImages() {
            let variant = currentSelectedComboProperties();
            if (!variant || variant[6] == null) return;

            let $swiper = $('.swiper-product-images');
            let $slides = $swiper.find('.swiper-slide');
            let $target = $slides.filter('[data-media="' + variant[6] + '"]');

            if (!$target.length) return;

            let index = $slides.index($target);
            if (index < 0) return;

            if (productSwiper) {
                productSwiper.slideTo(index);
            }

            // només en mòbil: portar la vista al top del slider
            if (window.innerWidth <= 768 && $swiper.length) {
                let headerHeight = $('.header-menu').outerHeight() || 0;
                let top = $swiper.offset().top - headerHeight - 10;

                $('html, body').animate({
                    scrollTop: top
                }, 300);
            }
        }

        // set button styles according to availability
        function setButtonStyle(but) {
            if (!but || !but.dataset || !but.dataset.variation) return null;

            const [levelStr, pname] = but.dataset.variation.split("|");
            const level = parseInt(levelStr, 10);

            let filt = [];

            for (const combo of availableCombos) {
                const cols = combo[0].split(" / ");
                if (cols[level] == pname) filt.push(combo);
            }

            if (filt.length === 0) {
                console.info("Invalid Combo");
                return null;
            }

            for (let s = 0; s < sections.length; s++) {
                if (s === level) continue;

                let dropdowns = false;
                let buttons = sections[s].getElementsByClassName("variant_option");

                if (buttons.length === 0) {
                    buttons = $(sections[s]).find(".variant_option_dropdown>option");
                    dropdowns = true;
                }

                for (const el of buttons) {
                    el.classList.remove("product-unavailable");
                    el.classList.remove("butNo");

                    if (!dropdowns && el.parentElement) {
                        el.parentElement.classList.remove("butNoStock");
                        el.parentElement.classList.remove("butNo");
                    }

                    let flag = "butNo";

                    for (const combo of filt) {
                        const cols = combo[0].split(" / ");

                        for (let r = 0; r < cols.length; r++) {
                            if (r === level) continue;

                            if ((r + "|" + cols[r]) == el.dataset.variation) {
                                el.classList.remove(flag);

                                if (!dropdowns && el.parentElement) {
                                    if (flag == "product-unavailable") {
                                        el.parentElement.classList.remove("butNoStock");
                                    } else {
                                        el.parentElement.classList.remove(flag);
                                    }
                                }

                                flag = "";
                                if (!combo[2]) flag = "product-unavailable";

                                if (dropdowns && flag === "") {
                                    el.innerHTML = el.dataset.variation.split("|")[1];
                                    el.disabled = false;
                                }

                                break;
                            }
                        }
                    }

                    if (flag.length) {
                        el.classList.add(flag);

                        if (dropdowns) {
                            if (flag == "product-unavailable") {
                                el.innerHTML = el.dataset.soldout || el.innerHTML;
                                el.disabled = true;
                            }
                        }

                        if (!dropdowns && el.parentElement) {
                            if (flag == "product-unavailable") {
                                el.parentElement.classList.add("butNoStock");
                            } else {
                                el.parentElement.classList.add(flag);
                            }
                        }
                    }

                    if (currentSelected[s] == el) {
                        el.classList.add("butSelect");
                        if (!dropdowns && el.parentElement) el.parentElement.classList.add("butSelect");
                    } else {
                        el.classList.remove("butSelect");
                        if (!dropdowns && el.parentElement) el.parentElement.classList.remove("butSelect");
                    }
                }
            }
        }

        // init all controls ids and disable unavailable
        function initComboCheck(variants, variation_sections) {
            availableCombos = [];
            currentSelected = [];
            sections = variation_sections;

            let vars = JSON.parse($(variants).html());

            for (let i = 0; i < vars.length; i++) {
                let v = vars[i];
                // DON'T CHANGE FIELD ORDER
                availableCombos.push([
                    v["title"],
                    v["id"],
                    v["available"],
                    v["inventory"],
                    v["price"],
                    v["compare_at_price"],
                    v["media"]
                ]);
            }

            let level = 0;

            for (const section of sections) {
                section.id = level;

                let dropdowns = false;
                let buttons = section.getElementsByClassName("variant_option");

                if (buttons.length === 0) {
                    buttons = $(section).find(".variant_option_dropdown>option");
                    dropdowns = true;
                }

                for (const but of buttons) {
                    const optionValue = normalizeOptionValue(but.value);
                    but.dataset.variation = level + "|" + optionValue;

                    but.disabled = true;

                    for (const combo of availableCombos) {
                        const cols = combo[0].split(" / ");
                        if (cols[level] == optionValue) {
                            but.disabled = false;
                            break;
                        }
                    }

                    if (dropdowns && $(but).is(":selected")) {
                        currentSelected[level] = but;
                        $(but).addClass("butSelect");
                    } else if (but.checked) {
                        currentSelected[level] = but;
                        but.classList.add("butSelect");
                        if (but.parentElement) but.parentElement.classList.add("butSelect");
                    }
                }

                // fallback si no hi ha res seleccionat
                if (!currentSelected[level]) {
                    if (dropdowns) {
                        const firstEnabled = $(buttons).filter(function () {
                            return !this.disabled;
                        })[0];
                        if (firstEnabled) {
                            firstEnabled.selected = true;
                            currentSelected[level] = firstEnabled;
                            $(firstEnabled).addClass("butSelect");
                        }
                    } else {
                        for (const but of buttons) {
                            if (!but.disabled) {
                                currentSelected[level] = but;
                                but.classList.add("butSelect");
                                if (but.parentElement) but.parentElement.classList.add("butSelect");
                                break;
                            }
                        }
                    }
                }

                level++;
            }

            for (let i = sections.length - 1; i >= 0; i--) {
                if (currentSelected[i]) setButtonStyle(currentSelected[i]);
            }
        }

        function currentSelectedToComboString() {
            if (!currentSelected.length || !currentSelected[0] || !currentSelected[0].dataset.variation) {
                return null;
            }

            let comboPath = currentSelected[0].dataset.variation.split("|")[1];

            for (let l = 1; l < sections.length; l++) {
                if (!currentSelected[l] || !currentSelected[l].dataset.variation) return null;
                comboPath += " / " + currentSelected[l].dataset.variation.split("|")[1];
            }

            return comboPath;
        }

        function comboStringToCombo(pname) {
            if (!pname) return null;

            for (const combo of availableCombos) {
                if (combo[0] == pname) {
                    return combo;
                }
            }

            return null;
        }

        function currentSelectedComboProperties() {
            return comboStringToCombo(currentSelectedToComboString());
        }

        function checkCombo(but) {
            if (!but || !but.dataset || !but.dataset.variation) return;

            const [levelStr] = but.dataset.variation.split("|");
            const level = parseInt(levelStr, 10);

            currentSelected[level] = but;

            setButtonStyle(currentSelected[level]);

            let newBut = but;

            for (let l = 0; l < sections.length; l++) {
                if (l != level && $(currentSelected[l]).hasClass("butNo")) {
                    $(sections[l]).find("[data-variation]").each(function () {
                        if (!$(this).hasClass("butNo") && !$(this).hasClass("product-unavailable") && !this.disabled) {
                            newBut = $(this)[0];
                            return false;
                        }
                    });

                    if (currentSelected[l] != newBut) {
                        currentSelected[l] = newBut;
                        setButtonStyle(currentSelected[l]);
                    }
                }
            }

            setButtonStyle(currentSelected[level]);

            for (let l = 0; l < sections.length; l++) {
                for (const optionBut of sections[l].getElementsByClassName("variant_option")) {
                    if (currentSelected[l] == optionBut) {
                        optionBut.classList.add("butSelect");
                        if (optionBut.parentElement) optionBut.parentElement.classList.add("butSelect");
                    } else {
                        optionBut.classList.remove("butSelect");
                        if (optionBut.parentElement) optionBut.parentElement.classList.remove("butSelect");
                    }
                }
            }
        }

        // handle variants clicks (swatches)
        $(document).on("click", ".variant_option", function () {
            checkCombo($(this)[0]);
            refreshPrice();
            GotoImages();
        });

        // handle dropdown changes
        $(document).on("change", ".variant_option_dropdown", function () {
            const selected = $(this).find("option:selected")[0];
            if (!selected) return;

            checkCombo(selected);
            refreshPrice();
            GotoImages();
        });

        $(document).ready(function () {
            if (typeof initComboCheck === "function" && $("#variants-json").length) {
                initComboCheck($("#variants-json"), $("[name='variant_section']"));
                refreshPrice();
            }
        });
    }
};

Variations.init();